import React from "react";
import Header from "../Header";
import Footer from "../Footer";

import { Link } from "react-router-dom";
import AudioPlayer from "../Audio/AudioPlayer";

const BlogDetails15 = (props) => {
  const img1 = "/assets/wp-content/uploads/2018/12/ramdev-gallery17.jpg";
    return (
        <>
         <meta name="keywords" content="બાબા રામદેવ , રામદેવજી,  રામદેવ પીર, રામશા પીર, Baba Ramdev, Ramdevji, Ramdev Pir, Ramshapir" />
      
            {/* <div className="body_wrap">
        <div className="page_wrap"> */}


            <Header />
            <div
                data-elementor-type="cpt_layouts"
                data-elementor-id="46"
                className="elementor elementor-46"
            >
                <section
                    className="elementor-section elementor-top-section elementor-element elementor-element-52ebb12  elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                    data-id="52ebb12"
                    data-element_type="section"
                    data-settings='{"background_background":"classic"}'
                    style={{ height: "30rem", marginBottom: "5rem" }}
                >
                    <div className="elementor-background-overlay"></div>
                    <div className="elementor-container elementor-column-gap-extended">
                        <div
                            className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-ae9d67e sc_inner_width_none sc_layouts_column_icons_position_left"
                            data-id="ae9d67e"
                            data-element_type="column"
                        >
                            <div className="elementor-widget-wrap elementor-element-populated">
                                <section
                                    className="elementor-section elementor-inner-section elementor-element elementor-element-fcf91b3 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                                    data-id="fcf91b3"
                                    data-element_type="section"
                                >
                                    <div className="elementor-container elementor-column-gap-extended">
                                        <div
                                            className="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-93dfaf4 sc_inner_width_none sc_layouts_column_icons_position_left"
                                            data-id="93dfaf4"
                                            data-element_type="column"
                                        >
                                            <div className="elementor-widget-wrap elementor-element-populated">
                                                <div
                                                    className="sc_layouts_item elementor-element elementor-element-847c2c5 sc_fly_static elementor-widget elementor-widget-spacer"
                                                    data-id="847c2c5"
                                                    data-element_type="widget"
                                                    data-widget_type="spacer.default"
                                                    style={{ height: "8rem" }}
                                                >
                                                    <div className="elementor-widget-container">
                                                        <div className="elementor-spacer">
                                                            <div className="elementor-spacer-inner"></div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div
                                                    className="sc_layouts_item elementor-element elementor-element-8fe49e3 sc_fly_static elementor-widget elementor-widget-trx_sc_layouts_title"
                                                    data-id="8fe49e3"
                                                    data-element_type="widget"
                                                    data-widget_type="trx_sc_layouts_title.default"
                                                >
                                                    <div className="elementor-widget-container">
                                                        <div
                                                            id="trx_sc_layouts_title_515615674"
                                                            className="sc_layouts_title sc_align_center with_content without_image without_tint"
                                                        >
                                                            <div className="sc_layouts_title_content">
                                                                <div className="sc_layouts_title_title">
                                                                    {" "}
                                                                   
                                                                </div>
                                                                <div className="sc_layouts_title_breadcrumbs">
                                                                    <div className="breadcrumbs">
                                                                           
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>{" "}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            {/* <div className="menu_mobile_overlay"></div>
      <div className="menu_mobile menu_mobile_fullscreen scheme_inherit">
        <div className="menu_mobile_inner">
          <a className="menu_mobile_close icon-cancel"></a>
          <Link to={'/'} className="sc_layouts_logo">

            <img
              src={logoimg}
              alt="Vihara"
              width="134"
              height="78"
            />{" "}
          </Link>
          <nav
            className="menu_mobile_nav_area"
            itemScope
            itemType="//schema.org/SiteNavigationElement"
          >
            <ul id="menu_mobile_1510458944">
              <li
                id="menu_mobile-item-203"
                className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-203"
              >
                <a href="/">
                  <span>Home</span>
                </a>

              </li>
              <li
                id="menu_mobile-item-204"
                className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-204"
              >
                <a href="#">
                  <span>Gallery</span>
                </a>
                <ul className="sub-menu">
                  <li
                    id="menu_mobile-item-209"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-209"
                  >
                    <a href="/Audio">
                      <span>Audio</span>
                    </a>
                  </li>
                  <li
                    id="menu_mobile-item-208"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-208"
                  >
                    <a href="/Video">
                      <span>Video</span>
                    </a>
                  </li>
                  <li
                    id="menu_mobile-item-206"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-206"
                  >
                    <a href="/Gallery2">
                      <span>Images</span>
                    </a>
                  </li>

                </ul>
              </li>
              <li
                id="menu_mobile-item-224"
                className="menu-item menu-item-type-custom menu-item-object-custom current-menu-ancestor current-menu-parent menu-item-has-children menu-item-224"
              >
                <a href="#">
                  <span>About</span>
                </a>
                <ul className="sub-menu">
                  <li
                    id="menu_mobile-item-447"
                    className="menu-item menu-item-type-post_type menu-item-object-page current-menu-item page_item page-item-407 current_page_item menu-item-447"
                  >
                    <a
                      href="/About"
                      aria-current="page"
                    >
                      <span>Ashram</span>
                    </a>
                  </li>

                  <li
                    id="menu_mobile-item-449"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-449"
                  >
                    <a href="/plan-visit">
                      <span>Plan a Visit</span>
                    </a>
                  </li>
                </ul>
              </li>

              <li
                id="menu_mobile-item-316"
                className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-316"
              >
                <a href="/BlogMain">
                  <span>Stories</span>
                </a>
              </li>
              <li
                id="menu_mobile-item-312"
                className="menu-item menu-item-type-post_type menu-item-object-page menu-item-312"
              >
                <a href="/Books">
                  <span>Books</span>
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
 */}



            <div className="page_content_wrap blog-details">
                <div className="content_wrap" >
                    <div className="content">
                        <div id="container" className="give-wrap container">
                            <div id="content" role="main">
                                <div
                                    id="give-form-288-content"
                                    className="post-288 give_forms type-give_forms status-publish has-post-thumbnail"
                                >
                                    <div
                                        id="give-sidebar-left"
                                        className="give-sidebar give-single-form-sidebar-left"
                                    >
                                        <div className="images">
                                            <img
                                                width="1024"
                                                height="576"
                                                src={img1}
                                                className="attachment-large size-large wp-post-image blog-img"
                                                alt=""
                                                decoding="async"
                                                sizes="(max-width: 1024px) 100vw, 1024px"
                                            />
                                        </div>
                                    </div>
                                    <div className="summary entry-summary">
                                        <h2 itemProp="name" className="give-form-title entry-title">
                                            ધર્માંધ સિકંદર નમ્યો !


                                        </h2>{" "}
                                        <div
                                            id="give-form-288-wrap"
                                            className="give-form-wrap give-display-onpage"
                                        >
                                            <div className="give-goal-progress">
                                                <div
                                                    className="raised blog-title"
                                                   
                                                >
                                                    <span className="income">ધર્માંધ સિકંદર નમ્યો !

                                                    </span>
                                                </div>
                                            </div>

                                            <div
                                                id="give-form-content-288"
                                                className="give-form-content-wrap give_pre_form-content"
                                            >
                                                <p className="paragraph-content">
                                                    સાખી
                                                    સ્થળે સ્થળે ગાજી રહ્યો, ‘રામતુંહી'નો જાપ, નમ્યો દિલ્હીનો બાદશાહ, જોથો પીર પ્રતાપ. કાળબળના કારણે દિલ્હીના રાજસિહાસન પર વિધર્મીઓનાં પગરણ થયાં અને મેં સિહાસન ગોઝારું બની ગયું.
                                                    દિલ્હીપતિ અનંગપાળ તુંવરાની રાજ્યવ્યવસ્થા કંઈક ટકી અને કંઈક ડગી. ત્યારબાદ સગા માસીયાઈ પૃથ્વીરાજ અને જયચંદમાં ખટરાગ થતાં વેરઝેરનાં બીજ મુસ્લિમ બાદશાહી ધ્વજ દિલ્હી પર ફરકતો કરી પોતાની આણ ફેરવી. તેમ છતાં વાયાં. દિલ્હીનું રાજ્ય ડહોળાયું અને વિધર્મીઓએ હિન્દુરાજને ઊથલાવી ૭ રાજ્યમાં સ્થિરતા આવી ન હતી.
                                                    સત્તાના મદમાં છકી જવાથી પ્રજાપાલનનું મહત્ત્વનું કાર્ય વિસારે પડ્યું. કુટુંબમાં વિખવાદ પેઠો. અંદરોઅંદર એકબીજાની હત્યા કરવાનાં કાવતરાં ગાવા લાગ્યા. આવા ગોઝારા સમયમાં લાહોરમાં બહલોલ લોદી સૂબો હતો . એણે દિલ્હી પર ચઢાઈ કરી વિજય મેળવ્યો અને સૂબામાંથી સમ્રાટ બની ગયો.
                                                    બહલોલનું મૃત્યુ થતાં એનો પુત્ર સિકંદર લોદી દિલ્હીની ગાદીએ બેઠો. અનેક હિંદુ રાજાઓએ એના સમ્રાટપદને અનુમોદન આપ્યું, તેમ છતાં તે હિન્દુઓને દુઃમન ગણી પાપાચારને પંથે વળ્યો. રાજાઓને શત્રુ માનીને ડરાવવા લાગ્યો અને હિન્દુઓના દેવસ્થાનો તોડવાં, દેવદેવીઓની મૂર્તિઓ ઉખેડી નાખવી, ખંડીત કરવી, તોડીને ફેંકી દેવી, સાધુ તથા બ્રાહ્મણોને રંજાડી કાઢી મૂકવા. આવા અત્યાચારથી હિન્દુઓના હૃદય દ્રવી ઊઠ્યાં. શહેર કે ગામડામાં સ્થળે સ્થળે એનાં ક્રૂર કૃત્યની વાતો થઈ.
                                                    ચોપાઈ
                                                    દિલ્હી પતિ સિકંદર લોદી હિન્દુ દેવળો નાખે ખોદી દેવમૂર્તિઓ તોડી પાડે, સાધુ સંતને બહુ રંજાડે. દિલને ધ્રુજાવે એવા આચરણોથી હિન્દુ રાજાઓ અને પ્રજા પર ધાક બેસાડવા

                                                </p>
                                                <p className="paragraph-content">
                                                    સિકંદર લોદી સીતમગર બન્યો.
                                                    ચોપાઈ
                                                    વિપ્રને વેરી ગણતો ભારે, ભજનીકોને દમથી ડારે, ધર્મ અધર્મ ન સમજે કાંઈ, સાધુ સંતથી શત્રુતાઈ. સિકંદર ઘાતકી હતો. બ્રાહ્મણો, સાધુ- સંતો અને ભજનીક ભક્તોને મ ડરાવવા તેને મન સહેજ વાત હતી. મહાત્મા કબીરને પણ એણે કાશીમાં જ
                                                    આપ્યો હતો.
                                                    માલ
                                                    એક વાર દિલ્હીનો શાહી સૂબો શહેર અને ગામડાં તપાસવા નીકળ્યો. એક
                                                    ફરતો હુડા કાશ્મીરમાં આવ્યો.
                                                    ચોપાઈ
                                                    નગર ગ્રામ્યને રહ્યો તપાસી, સૂબો દિલ્હી થયો પ્રવાસી
                                                    આવ્યો એ હુડા કાશ્મીરે, સનમાન્યો સુરસંગ સુધીરે. સૂબાને સુરસંગે એના મોભા પ્રમાણે સન્માન સત્કાર કરી, મોટા ચોરા ઉતારો આપ્યો અને એની સુખ સગવડ માટે પોતાના માણસોને રોક્યા. તે મનપસંદ ભોજન-સામગ્રી માટે પણ પૂરતી વ્યવસ્થા કરવી.
                                                    દોહા
                                                    નિત્ય ભીમ નિશા સમે, ભજનો ચોહર ગાય,
                                                    ભક્તિ ભાવે સુરની, પીરાઈ વધતી જાય.
                                                    ગુરુ લખમાના આદેશ આજ્ઞા પ્રમાણે સુ૨સંગ દર બીજ અને પૂનમે રણુંજા જતા. તેમનો હંમેશ નિયમ હતો કે રાત્રે શ્રી રામદેવજીની પ્રાર્થના યશોગાન તથા કીર્તિના ભજનો-ચોહર ગાયા પછી નિદ્રાધિન થયું. આજે રાતના નવ વાગ્યાના સુમા રાજમહેલમાં કોઈ ગાતું હોય એવો અવાજ સૂબાને સંભળાવ્યો. તેથી તહેનાતમ રોકાયેલા માગ઼સોને તેણે પૂછ્યું : ‘અત્યારે રાત્રે કોણ ગાય છે ?’
                                                    નામવર ! મહારાજને નિત્યનો નિયમ છે કે, રાત્રે ચાર ભજન ગાયા પછી
                                                    સૂઈ રહેવું. તેથી સુરરાજા અત્યારે ભજન ગાવા બેઠા છે.'
                                                    ‘ભજન ! શેનાં ભજન ? એ શું ગાય છે ?’ સૂબાએ પૂછ્યું.. ‘અમારા ઇષ્ટદેવ શ્રી રામદેવપીરનાં ભક્તિભાવે સૌ કોઈ ભજનો ગાય પણ અત્યારે તો મહારાજ પોતે ગાઈ રહ્યા છે.' માણસે કહ્યું.

                                                </p>
                                                <p className="paragraph-content">
                                                    ને કહો હું સાંભળવા આવું છું.' સૂબો તૈયાર થયો અને માણસે સુરસંગને તે રાજી થયા. સૂબાને ગાદીતક્રિયા પર બેઠક આપી. સુબો બેઠો અને
                                                    મને ભજનના લલકાર કર્યો.
                                                    "રસગના લલકાર, રામસાગરનો મેળ, મનની એકાગ્રતા અને ભજનોમાં હેવાનું નામ આપે છે ? એવી સૂબાના મનમાં ભાંજગડ થવા લાગી. સુબાએ જ પાર શબ્દોથી સૂબો તર્કવિતર્કમાં પડ્યો કે, પીર-પીર કહે છે અને ધરનું નામ સાંભળ્યું. એને નવાઈ લાગી. ભજનો સાંભળી સૂબો ઉતારે . બીજે દિવસે દિલ્હી ગયો અને તેણે સિકંદરને વાત કરી,
                                                    ચોપાઈ
                                                    રજપૂત ક્ષત્રી સુરસંગ નામે, રાજા હુડા કાશ્મીર ગામે, હિન્દવાપીરની કરતો પૂજા, પીર રામદે' ગામ રણુજા. મેવાડનાં હુડા કાશ્મીર ગામનો રાજાસુરસંગ જાતનો ક્ષત્રી છે. તે રણુંજા ગામના ગુજરામદેવને પીર ગણી પૂજા કરે છે. રાતદિવસ પીરની પીરાઈ સિવાય બીજી વાત રતો નથી. પ્રજા પણ એને પીર માને છે. એ સુરસંગને કેટલાક સુરસંત નામથી દરે ફરમાન કર્યું : ‘સુરસંગને અહીં તેડી લાવો.' હુકમ થતાં માણસો સુરસંગને ધે છે. આવી ઘણી વાતો કરી સૂબાએ સિકંદરને ઉશ્કેર્યો. સૂબાની વાત સાંભળી દિલ્હી આવ્યા. સૂબાએ સન્માન કરી રાજા સુરસંગને ઉતારો આપ્યો, પરંતુ કરમાં છળકપટ હતું. તે છુપાવીને સુરસંગને પોતાના વિશ્વાસમાં લઈ સવારમાં કરીમાં હાજર કર્યા.
                                                    હાથમાં રામસાગર-તંબૂરો, કાનની બૂટમાં કુંડલ, હાથમાં બેરખો, ગળામાં તુલસીની માળા, માથે પાઘડીમાં કેસરી રંગનો ફટકો, શરીરનો બેવડો બાંધો, ભરાવદાર મોઢું, મોટી મરોડદાર મૂછો, વિશાળ તેજસ્વી નેત્રો અને હાથમાં ભરેલું કમંડળ. એવી ભવ્ય વિભૂતિ સુસંગને સિકંદર ઘડીભર જોઈ રહ્યો, પરંતુ ર્મઝનૂનથી તે બોલ્યો :
                                                    ચોપાઈ
                                                    હિંદુઓમાં ભિન્ન ભિન્ન જાતિ, પૂજાવિધિ અનેક ભાતી, રામદેવ ક્ષત્રી વર્ણ હોઈ, પીરાઈઓમાં ના'વે કોઈ. ‘તમારું નામ શું ?’ સિકંદરે પૂછ્યું.
                                                </p>
                                                <p className="paragraph-content">
                                                    'હિન્દુમાં પીર ના હોય. જુદી જુદી જ્ઞાતિ, જુદા જુદા દેવ, જુદી જુદી ખૂબ રાજપૂત છે. એને ગરાસ વગેરે છે, છતાં પીર બનીને પૂજાવાની ઇચ્છા રાખે તેમ ધર્મમાં જુદાં જુદાં મતમતાંતર, એમાં કોઈ પીરાઈવાળા હોય જ નહીં. રાખવાનું
                                                    તૂત ઊભું કર્યું છે.’ સિકંદરે કહ્યું.
                                                    'ભાદશાહ ! રામદેવજી મહારાજ એ તો ‘અલખ’ છે. ખલકના ખવિ છે એમની પ્રગટ પીરાઈ છે. કોઈ સાધારણ નથી. આપને કોઈએ સમજાવ્યું હોય તેવ રામદેવ નથી. એ તો પતિતપાવન છે. બાદશાહી, સામંતશાહી, રાશ શ્રીમંતશાહી કે બેંક સ્થિતિ એ બધાં એમના કૃપાવૃક્ષનાં ફળ છે અને કર્મ ફળ આપે છે.’ સુરસંગે કહ્યું.
                                                    પ્રમાણે સોન
                                                    ખડખડાટ હસી પડ્યા અને બોલવા લાગ્યા કે, આ કોઈ રામદેવનો ચેલો છે ! રામદેવે સુરસંગની વાત સાંભળી સિકંદર, સૂબો અને કચેરીમાં બેઠેલા માણસ ખરો પાગલ બનાવ્યો છે. થોડી વારે સૂબો બોલ્યો : ‘ભગત ! તમારો રામદેવ એવ પ્રતાપી છે તો પોકરણ, રણુંજા અને ફળોજી નામનાં ગામડાંનો રાજા કેમ થયો છે. ત્રણે ગામડાંને બાદશાહ સિકંદર એક ફૂંક મારી ઘડીકમાં ઉડાડી દેશે માટે પીરાઈનું
                                                    એ
                                                    તૂત છોડી દો.”
                                                    ‘સૂબા ! શેહશરમ કે ડર દબાણને વશ થઈ સત્યને છોડી દઉં એવો હું નથી. રામદેવજીમાં મને સાચા પીરનાં દર્શન થયાં છે, એટલે હું સાચી વસ્તુને શી રીતે છોડી દઉં ?
                                                    શ્રી
                                                    દોહા
                                                    પવન ન પકડો પોશમાં, રહે પાણીનું માપ,
                                                    પીરાઈ વરુણ ન સંભવે, વ્યાપક વાયુ આપ.
                                                    ખોબામાં પવન રાખી શકશો નહિ, ખોબામાં પાણી રહે. રામદેવજી તો વાયુ જેમ સર્વત્ર વ્યાપક છે. હે બાદશાહ ! ધર્મ અને અધર્મની ભાંજગડમાં પડશો નહીં. પ્રજા ગમે તે ધર્મને માને એમાં બાદશાહે અંતરાયરૂપ થવું જોઈએ નહીં. સુરસંગે
                                                    બોધદાયક વચનો કહ્યાં.
                                                    દોહા
                                                    આસ્તિક, નાસ્તિક બેય ગુણ, માન્યામાં અવરોધ,
                                                    પલ્લાં
                                                    સમતોલાં રહ્યાં, કાંટો કરતો બોધ.
                                                    .
                                                </p>
                                                <p className="paragraph-content">
                                                    બાદશાહ
                                                    છે.
                                                    * :
                                                    બનાવ સિકંદર નથી!
                                                    ! કોઈ પણ ધર્મ હોય તે, માનવ જાતિને પરસ્પર ટેકારૂપ થવા માટે

                                                    સ્વાર્થ કે ધર્મનાં ઓઠાં તળે પરસ્પરને નિંદવા અને પોતે આસ્તિક છે.
                                                    ને સામા પક્ષ નાસ્તિક છે એમ માનવું એ યોગ્ય નથી. હે ભૂપ ! તમે જેને નાસ્તિક રે એ બીજી રીતે પણ ધર્મ પાળતો હોય છે. એને એમાં શ્રદ્ધા છે. તમે તમારા અને મનથી ધર્મમાં શ્રદ્ધા રાખીને જ આસ્તિક બન્યા છો. તમે પ્રજાના પિતા • તમારે મન બધા જ સરખા હોવા જોઈએ. બંને પલ્લાં સરખાં રહે છે, એની સાક્ષી
                                                    એનો કાંટો પૂરે છે.
                                                    બત કરી પરંતુ એથી ધર્મ ભૂંસાઈ જતો નથી. ધર્મનું ઘર તો આસ્તિકનું મન હોય હૂં નામવર ! તમે હિન્દુ દેવળો તોડ્યાં, મૂર્તિઓને ઉખેડી, ભાંગી, તોડી તથા છે. જે બાદશાહ ! તમે બાદશાહી મેળવી એ તો લશ્કરના માણસોના બળથી મેળવી સળંગ રહી નથી અને રહેવાની પણ નથી. ચડતીપડતી એ તો પ્રકૃતિનો ક્રમ છે. છે, ના દિલ્હીના સિંહાસન પર પરંપરાથી ઊથલપાથલ થતી જ આવે છે. બાદશાહી
                                                    એને કોઈ ફેરવી શકે નહીં.
                                                    આ સિંહાસન પર ક્ષત્રી રાજપૂત અનંગપાળ નુંવર હતો. એના વંશના રામદેવજી મહારાજ છે. તે એમના વારસ છે આ સિંહાસન પર, તેમનો અધિકાર એ ધારે તો ગમે તેવી રાજશાહી કે બહુબળવંતી બાદશાહીને ઉથલાવી નાખે.
                                                    દોહા
                                                    સિકંદરને સુરનો, સહેજ ન લાગ્યો બોધ;
                                                    અહંકારથી ઉચ્ચર્યો, અંગે વ્યાપ્યો ક્રોધ.
                                                    “અરે, પાખંડી ! તારો રામદે' આ સિંહાસનનો અધિકારી વારસ છે ?’ એટલો કો બળવાન છે તો ત્રણ ગામઠીનો ગિરાસદાર કેમ રહ્યો છે ?' સિકંદર શાહની વ્રત સાંભળી સુ૨ાજા ક્રોધ ન કરતાં શાંતિથી બોલ્યા :
                                                    ‘બાદશાહ ! રામદે’જી તો આલમ-રાજા છે. ત્રણ ગામડાનાં ગિરાસદાર નહીં, તો ત્રણ ભુવનના નાથ છે ! તમે બાદશાહી ભોગવો છો એની કૃપાથી જ ભોગવો મે!' સુરસંગે કહેલી નિડર વાણી સાંભળી સિકંદરના હૃદયમાં ક્રોધની જ્વાળા મૂકી ઊઠી, તે તાડૂકીને બોલ્યો :
                                                    'સૂબા ! વજ્રની કોઠી લાવો અને કચેરીમાં મૂકો. આ ભગતડાને એમાં પૂરીને | ગળાવી મારો.' સૂબે લોઢાની મોટી કોઠી મંગાવી કચેરીમાં મૂકી.
                                                    ‘એક ~~~′′ ! પાખંડી ! તારા રામદે'ને હવે મારું સિંહાસન જોવા તેડાવ !

                                                </p>
                                                <p className="paragraph-content">
                                                    અમે પણ એની પીરાઈનાં પાખંડને અને શક્તિને જાણી શકીએ ! ઉંઘાડો કાઠી અને
                                                    પૂરી દો આ પાખંડીને.’ સિકંદરે હુકમ કર્યો.
                                                    દોહા
                                                    એ... ચડો રેવતે રામદે' ઘરી હાથમાં તીર, આરાધે ઘણી આવજો, પ્રભુ રામદેપીર. એટલો ઉચ્ચાર કરી સુરસંગ પોતાની મેળે જ કોઠીમાં ઊતર્યા. ચોપાઈ
                                                    સુરસંગ બેઠા વાળી પલાંઠી, સૂબે બંધ કરી વજ્જર કોઠી, અખંડ ધૂન ‘તુંહી રામ’ ઉચ્ચારા, ગુંજ્યો નાદ રવે રણંકારા. સુરસંગે કોઠીમાં ઊતરતાં ‘જય રામદેવજી' ! જય અલખધણી ! ‘રામનું ‘રામતુંહીનો’ અખંડ જાપ જપતાં ધૂન શરૂ કરી. બાદશાહ, સૂબો અને અન્ય માંડલિકો કચેરી બહાર આવ્યા. દ્વાર બંધ કરી, તાળાં મારી બે હથિયારબં
                                                    ચોકીદારોને ત્યાં મૂક્યા.
                                                    દોહા
                                                    સિકંદર અને સૂબો, મનમાં હરખાય,
                                                    શબ મોકલવું સુરનું, ગામ રણુંજા માંય.
                                                    બંનેએ નિશ્ચય કર્યો કે આ પાખંડી ગૂંગળાઈને મરણ પામે ત્યારે એના મડદાને રણુંજામાં રામદે’ને ભેટ મોકલવું. આવો વિચાર કરી બાદશાહ મહેલમાં આવ્યો. ચોપાઈ
                                                    રામતુંહીના બુલંદ અવાજે, ભીતર બાહીર કોઠી ગાજે,
                                                    વધ્યો નાદ વ્યાપક વિસ્તારા, પહોંચ્યો શાહીમહેલ મોજારા. ‘રામતુંહી’નો અવાજ કોઠીમાંથી બહાર આવ્યો. ધીમે ધીમે તે વ્યાપક અને બુલંદ બન્યો અને કચેરી વિસ્તાર તથા બંધ કરેલા દ્વારને ભેદી બાદશાહના મહેલમાં સંભળાવા લાગ્યો.
                                                    દોહા  માજમરાતે મહેલમાં, ઘોર નાદ ઘૂંટાય ! ચોંકી ઊઠ્યો. બાદશાહ, ‘રામતુંહી’ સંભળાય.

                                                </p>
                                                <p className="paragraph-content">


                                                    શયનખંડ બેગમનો ગાજે, રામતુંહીના ઘોર અવાજે.
                                                    ધ્રૂજે બેગમ ભયભીત થાતી, મૂર્છા ખાઈને પછડાતી. બેગમનાં શયનખંડમાં સ્થળે સ્થળે રામતુંહીનો અવાજ થતાં તે ભયભીત બની પૂજવા લાગી. તે હિંમત હારી ગઈ અને ચીસ પાડીને મૂર્છા ખાઈ જમીન ઉપર પછડાઈ પડી
                                                    ચોપાઈ

                                                    દાસ દાસીઓ થરથર ધ્રૂજે, રામતુંહીનો અવાજ ગુંજે !
                                                    શાહ દોડતો આવ્યો ત્યાંયે, સ્થળ સ્થળ નાદ પ્રગટતો જાયે. બેગમ બાંદીઓ ગભરાઈને ધ્રૂજતી હતી તે વેળા બાદશાહ તુરત શયનખંડમાં દોડી ગયો અને બેગમને મૂર્છિત સ્થિતિમાં પડેલી જોઈ ગભરાયો.
                                                    દોહા
                                                    ખંડ. ભુવન પતિ ભયભીત બન્યો, ઓસરી ગયો. ઘમંડ, મહેલના ખંડે “રામતુંહી’થી ગાજતા,
                                                    મહેલનો ખંડેખંડ ગાજતો હતો અને બેગમની સ્થિતિ ગંભીર હતી. આ જોઈ
                                                    બાદશાહનો ઘમંડ ઓગળી ગયો. તે હિંમત હારી ગયો. કોઈ પણ હથિયાર કે હુબળથી તે આ ગેબીનાદને ખાળી શકે તેમ ન હતો.

                                                </p>
                                                <p className="paragraph-content">
                                                    ચોપાઈ
                                                    સૂબા તણા શયનગૃહ માંહે, ‘રામતુંહી’નો રવ સંભળાય, થોરનાદ ત્યાં વધતો જાયે, દિગ્મૂઢ થઈને સૌ ગભરાયે. સૂબો અને વજીર ભરનિદ્રામાં હતા. ત્યાં તેમના શયનખં ‘રામતુંહી’નો ઘોરનાદ ગુંજવા લાગ્યો. આ ચમત્કારિક નાદ સાંભળ આશ્ચર્યમાં ડૂબી ગયા. જોતજોતામાં એ નાદ શયનખંડના ખૂણેખૂણે પ્રસરી ગ
                                                    વધુ ને વધુ પ્રચંડ થવા લાગ્યો.
                                                    ચોપાઈ
                                                    બાંદી બેગમ ગયાં ગભરાઈ, તન ધ્રૂજે સૂઝે નહીં કાંઈ, ‘રામતુંહી’ના ઘોર અવાજે, શયનગૃહ સહુ ખૂણે ગાજે ! સૂબાની બેગમ દાસદાસીઓ આ અવાજ સાંભળી ગભરાઈ ગયાં અને ભ ચીસો પાડવા લાગ્યાં. પોતાના મહેલની આવી પરિસ્થિતિ જોઈ સૂબો દો બાદશાહ પાસે ગયો.
                                                    સૂબો અને બાદશાહ પોતાના અણધાર્યા સંકટની વાતો કરી રહ્યા છે, ત્યાં
                                                    દોહા
                                                    સનનન આવ્યું તીરને, કર્યો ઝુમ્મરનો નાશ,
                                                    તૂટીને વચ્ચે પડ્યું, બંધ થયો પરકાશ.
                                                    એકાએક સનનન કરતું એક તીર આવ્યું અને સભાખંડમાં ટાંગેલા કિંમતી ઝુમ્મરને વાગ્યું. ઘડીમાં ઝળહળતું ઝુમ્મર તૂટીને નીચે પડ્યું. બધે અંધકાર છવાઈ
                                                    ગયો !
                                                    આ બનાવ બનતાં જ મહેલના ચોકીદારો ત્યાં દોડી આવ્યા અને હાંફતા હાંફતા બોલવા લાગ્યા :
                                                    ચોપાઈ
                                                    નામવર અહીં કચેરી દ્વારે, ‘રામતુંહી’ કોઈ નાદ ઉચ્ચારે,
                                                    ‘રામતુંહી’ કહી તાળાં ડોલે, બોલનાર ક્યાંક છુપાઈ બોલે. નામવર ! જહાંપનાહ ! કચેરીમાં બધે જ ‘રામતુંહી’નો અવાજ થયા કરે છે, પરંતુ આ ગેબીનાદ ક્યાંથી આવે છે તે કોઈ જાણી શકતું નથી ! કોઈ છુપાઈને બોલે છે.' મહેલના ચોકીદારે આવીને કહ્યું.


                                                </p>
                                                <p className="paragraph-content">
                                                    અને બાદશાહને ‘રામનુંહી’ના થોરનાદનું મૂળ કારણ કચેરીમાં છે એમ બજાવી બધા કચેરીમાં આવ્યા. કચેરીનાં દ્વાર ખોલતાં વજ્રની કોઠી પાસે મૂકેલો - એકધારો રામતુંહીના રણકારથી રણઝણી રહ્યો હતો, વજની કોઠી પાસે અને સાભળ્યુ તો રામતુંહીના ઘોરનાદથી કોઠી ધ્રૂજી રહી હતી. “રામતુંહી'નું મૂળ એમાં એક બીજું સનનન કરતું તીર આવ્યું અને કોઠીના ઢાંકણાને લાગ્યું. તીર મ ના વજની કોઠીમાં છે. એમ બધાંને લાગ્યું. બધા વિચાર કરતી હતી નવરસ થાઈ ગયા. તેમને લાગ્યું કે હવે આપણે બચવું મુશ્કેલ છે, તેથી બંને જણા રતા કાઠીનું ઢાંકણ ઊછળીને વેગળું પડ્યું. આ ચમત્કારિક દૃશ્ય જોઈ સૂબો અને કોઠી પાસે જઈ મસ્તક ઝુકાવી બોલ્યા : “હે સુરરાજા ! અમારો વાંકગુનો માફ કાં.અમારી ભૂલની અમોને ક્ષમા આપો ! અને અમારા ઉપર કૃપા કરી કોઠીમાંથી ક્યારે આવી અમોને આશીર્વાદ આપો.’ બાદશાહની વિનંતિથી સુરરાજા કોઠીમાંથી ‘જય રામદેવપીર, અલખ ! શીનો જય !” કહેતા બહાર આવ્યા અને સહુને આશીર્વાદ આપી નિર્ભય બનાવ્યા. ગમતુંહીનો ભયાનક અવાજ બંધ થઈ ગયો !
                                                    શ્રીરામદેવજીની કૃપાનો આવો અદ્ભુત પરચો જોઈ બાદશાહ અને સૂબાએ સુરરાજા સાથે રણુંજા જઈ રામદેવજીને સોનાનું છત્ર ચડાવ્યું અને હિન્દુ ધર્મ ઉપરનો નિસ્કાર છોડી દીધો.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>{" "}
                </div>
            </div>
            {/* </div>
      </div> */}
            <div>
                <Footer />
                {/* <AudioPlayer state={props.state} onPlay={(isPlay) => this.setState({ isPlay })} /> */}
            </div>
        </>
    );
};

export default BlogDetails15;
